__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "web.shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/cdk/a11y", "20.2.14", () => (() => (__webpack_require__(65066))), 1);
			register("@angular/cdk/accordion", "20.2.14", () => (() => (__webpack_require__(39610))), 1);
			register("@angular/cdk/drag-drop", "20.2.14", () => (() => (__webpack_require__(93408))), 1);
			register("@angular/cdk/keycodes", "20.2.14", () => (() => (__webpack_require__(26357))), 1);
			register("@angular/cdk/overlay", "20.2.14", () => (() => (__webpack_require__(78444))), 1);
			register("@angular/cdk/portal", "20.2.14", () => (() => (__webpack_require__(1262))), 1);
			register("@angular/cdk/scrolling", "20.2.14", () => (() => (__webpack_require__(58951))), 1);
			register("@angular/cdk/text-field", "20.2.14", () => (() => (__webpack_require__(71526))), 1);
			register("@angular/common/http", "20.3.30", () => (() => (__webpack_require__(5879))), 1);
			register("@angular/common", "20.3.30", () => (() => (__webpack_require__(73410))), 1);
			register("@angular/core/primitives/di", "20.3.30", () => (() => (__webpack_require__(95659))), 1);
			register("@angular/core/primitives/signals", "20.3.30", () => (() => (__webpack_require__(16945))), 1);
			register("@angular/core/rxjs-interop", "20.3.30", () => (() => (__webpack_require__(64554))), 1);
			register("@angular/core", "20.3.30", () => (() => (__webpack_require__(72715))), 1);
			register("@angular/forms", "20.3.30", () => (() => (__webpack_require__(86944))), 1);
			register("@angular/platform-browser", "20.3.30", () => (() => (__webpack_require__(22916))), 1);
			register("@angular/router", "20.3.30", () => (() => (__webpack_require__(68127))), 1);
			register("@microsoft/applicationinsights-web", "3.3.11", () => (__webpack_require__.e(491).then(() => (() => (__webpack_require__(9491))))));
			register("rxjs/operators", "7.8.2", () => (() => (__webpack_require__(4734))), 1);
			register("rxjs", "7.8.2", () => (() => (__webpack_require__(81678))), 1);
			register("tslib", "2.8.1", () => (() => (__webpack_require__(36000))), 1);
			register("workbox-window", "7.4.0", () => (__webpack_require__.e(892).then(() => (() => (__webpack_require__(94892))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};